export default "__VITE_ASSET__B9TWnZ0p__"